import React from 'react';

import PlaceholderTab from '../../shared/PlaceholderTab';

import { CAMPAIGN_SCHEDULE_FIELDS } from './fields';

export default function CampaignSchedulesTab() {
  return <PlaceholderTab configuredFieldCount={CAMPAIGN_SCHEDULE_FIELDS.length} title="Campaign Schedules" />;
}
